import { PROJECTS, PROFILE } from "../data/constants";
import { IconArrow } from "./icons";

export default function Projects() {
  return (
    <>
      <section id="projects" className="sec">
        <p className="sec-marker reveal">{"// featured work"}</p>

        <div className="grid-work">
          {PROJECTS.map((p, i) => (
            <a
              key={p.title}
              className={`work-card reveal d${i + 1}`}
              href={p.href}
              target="_blank"
              rel="noreferrer"
            >
              <div className="work-head">
                <span>{p.kind}</span>
                <span className="work-arrow"><IconArrow width={14} height={14} /></span>
              </div>

              <div className="work-visual">
                <span className="work-glyph" aria-hidden="true">{p.glyph}</span>
              </div>

              <div className="work-body">
                <h3 className="h3">{p.title}</h3>
                <p className="prose" style={{ fontSize: 11.5, marginTop: 9 }}>{p.desc}</p>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 14 }}>
                  {p.tech.map((t) => <span key={t} className="chip">{t}</span>)}
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="reveal" style={{
          display: "flex", alignItems: "flex-end", justifyContent: "space-between",
          gap: 24, marginTop: 26, flexWrap: "wrap",
        }}>
          <p className="sec-marker" style={{ margin: 0, maxWidth: "30ch" }}>
            {"// source for everything lives on GitHub"}
          </p>
          <a className="btn" href={PROFILE.github} target="_blank" rel="noreferrer">
            All repositories <IconArrow width={13} height={13} />
          </a>
        </div>
      </section>

      <p className="watermark reveal" aria-hidden="true">
        SINCE<br /><span className="filled">2023</span>
      </p>
    </>
  );
}
